// Validation Type Constants
export const VALIDATOR_TYPE_REQUIRE = "REQUIRE";
export const VALIDATOR_TYPE_MINLENGTH = "MINLENGTH";
export const VALIDATOR_TYPE_MAXLENGTH = "MAXLENGTH";
export const VALIDATOR_TYPE_MIN = "MIN";
export const VALIDATOR_TYPE_MAX = "MAX";
export const VALIDATOR_TYPE_EMAIL = "EMAIL";
export const VALIDATOR_TYPE_FILE = "FILE";
export const VALIDATOR_TYPE_HAS_NUMBER = "NUMBER";
export const VALIDATOR_TYPE_PASSWORD = "PASSWORD";

// Validation Function
export const validateInput = (value, validator) => {
  let isValid = true;
  let errorMessage = "";

  switch (validator.type) {
    case VALIDATOR_TYPE_REQUIRE:
      isValid = isValid && value.trim().length > 0;
      errorMessage = isValid ? "" : "This field is required.";
      break;

    case VALIDATOR_TYPE_MINLENGTH:
      isValid = isValid && value.trim().length >= validator.val;
      errorMessage = isValid ? "" : `Minimum length ${validator.val} is required.`;
      break;

    case VALIDATOR_TYPE_MAXLENGTH:
      isValid = isValid && value.trim().length <= validator.val;
      errorMessage = isValid ? "" : `Maximum length ${validator.val} is required.`;
      break;

    case VALIDATOR_TYPE_MIN:
      isValid = isValid && +value >= validator.val; // Convert to number
      errorMessage = isValid ? "" : `Minimum length ${validator.val} is required.`;
      break;

    case VALIDATOR_TYPE_MAX:
      isValid = isValid && +value <= validator.val; // Convert to number
      errorMessage = isValid ? "" : `Maximum length ${validator.val} is required.`;
      break;

    case VALIDATOR_TYPE_EMAIL:
      isValid = isValid && /^\S+@\S+\.\S+$/.test(value);
      errorMessage = isValid ? "" : "Email format is incorrect.";
      break;

    case VALIDATOR_TYPE_FILE:
      isValid = isValid && value instanceof File; // Check if it's a file
      errorMessage = isValid ? "" : "File format is incorrect.";
      break;

    case VALIDATOR_TYPE_HAS_NUMBER:
      isValid = isValid && !/\d/.test(value);
      errorMessage = isValid ? "" : "Do not enter number.";
      break;

    case VALIDATOR_TYPE_PASSWORD:
      isValid = isValid && /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(value);
      errorMessage = isValid ? "" : "Please enter min 8 characters which has one special character, one uppercase, one number";
      break;

    default:
      console.error(`Unknown validator type: ${validator.type}`);
      break;
  }

  return {isValid, errorMessage};
};

// // Validate Field Using Multiple Validators
// export const isFieldValid = (value, validators, message) => {
//   return validators.every((validator) => validateInput(value, validator, message));
// };
